<template>
  <div class="know_job_link_card_components">
    <div class="know_job_link_card">
      <router-link :to="Link">
        <div class="card-main">
          <div class="image">
            <img :src="backImg" alt="">
          </div>
          <div class="text">
            <p class="catch" v-html="mainCatch">
            </p>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KnowJobLinkCard',
  props: {
    Link: String,
    mainCatch: String,
    infoText: String,
    backImg: String,
    isSmall: Boolean
  }
}
</script>

<style scoped lang="scss">
.know_job_link_card {
  max-width: 230px;
  width: 100%;
  height: auto;
  position: relative;
  margin-bottom: 3px;
  a {
    display: block;
    position: relative;
    &:after {
      content: "";
      width: 0%;
      height: 100%;
      display: block;
      position: absolute;
      top: 0;
      background-color: #e51c57;
      transition: width 0.2s cubic-bezier(0.77, 0, 0.175, 1);
    }
    &:hover {
      opacity: 1;
      &:after {
        width: 100%;
      }
    }
  }
}
.card-main {
  height: 160px;
  position: relative;
  .image {
    position: relative;
    &:after {
      content: "";
      width: 100%;
      height: 100%;
      display: block;
      position: absolute;
      top: 0;
      background-color: rgba(141, 28, 72, 0.5);
    }
    img {
      vertical-align: middle;
    }
  }
  .text {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .catch {
      z-index: 1;
      line-height: 2em;
      font-size: 12px;
      background-color: #fff;
      width: 150px;
      text-align: center;
      border-radius: 10px;
    }
  }
}
</style>
